function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable no-case-declarations */
/**
 * @ File: 主题跟随组件
 * @ Description: 根据站点信息实时更新主题色
 * @ Author: feeling
 * @ Create Time: 2023-09-28 16:12:22
 * @ Modified by: feeling
 * @ Modified time: 2023-09-28 16:13:43
 */

import { ConfigProvider } from 'antd';
import { useEffect, useState } from 'react';
import { findSiteData } from "../Utils/valueGet";
// @ts-ignore
import { useModel } from 'umi';
var doJSON = function doJSON(str) {
  if (Object.prototype.toString.call(str) === '[object String]') {
    try {
      var strObj = JSON.parse(str);
      return strObj;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
};

/**
 *
 * @param {string} prefixCls 样式前缀名
 * @param {string} storageKey 作为独立项目时，站点信息key名
 * @param {string} orderColor 指定主题颜色，优先级最高，指定后不获取站点信息
 * @return {boolean}
 */
var useThemeByMaster = function useThemeByMaster(prefixCls, storageKey, orderColor) {
  var masterModel = useModel('@@qiankunStateFromMaster');
  var _ref = masterModel || {},
    tag = _ref.tag,
    masterStore = _ref.masterStore,
    getOrganizationCode = _ref.getOrganizationCode,
    portalData = _ref.portalData;
  var getThemeColor = function getThemeColor() {
    var _portalData$currentPo, _findSiteData, _masterStore$siteStor, _findSiteData2;
    var themeColor = '';
    if (orderColor) {
      themeColor = orderColor;
    } else {
      var currentPortalCode = (getOrganizationCode === null || getOrganizationCode === void 0 ? void 0 : getOrganizationCode()) || '';
      switch (tag) {
        case 'portal':
          themeColor = (portalData === null || portalData === void 0 || (_portalData$currentPo = portalData[currentPortalCode]) === null || _portalData$currentPo === void 0 ? void 0 : _portalData$currentPo.themeColor) || '';
          break;
        case 'workbench':
          themeColor = ((_findSiteData = findSiteData((masterStore === null || masterStore === void 0 || (_masterStore$siteStor = masterStore.siteStore) === null || _masterStore$siteStor === void 0 ? void 0 : _masterStore$siteStor.siteData) || {}, 'theme_color')) === null || _findSiteData === void 0 ? void 0 : _findSiteData.value) || '';
          break;
        default:
          if (!storageKey) {
            themeColor = '';
          }
          var siteStore = doJSON(localStorage.getItem(storageKey) || '');
          if (!siteStore) {
            themeColor = '';
          }
          var _ref2 = siteStore || {},
            siteData = _ref2.siteData;
          themeColor = ((_findSiteData2 = findSiteData(siteData, 'theme_color')) === null || _findSiteData2 === void 0 ? void 0 : _findSiteData2.value) || '';
      }
    }
    return themeColor;
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    themeChanged = _useState2[0],
    setThemeChanged = _useState2[1];
  var themeColor = getThemeColor() || '#1890ff';
  useEffect(function () {
    ConfigProvider.config({
      prefixCls: prefixCls,
      theme: {
        primaryColor: themeColor
      }
    });
    setThemeChanged(true);
  }, [themeColor]);
  return themeChanged;
};
export default useThemeByMaster;